module.exports = __webpack_public_path__ + "static/media/Notice.0cc10d77.svg";